import { connect } from 'react-redux';

// Actions
import {
  addClientLocation,
  deleteClient,
  deleteClientLocation,
  getClientDetails,
  getClientLocation,
  updateClient,
  updateClientLocation,
} from '../clientsActions';
import { getJobList, deleteJob } from '../../Jobs/jobsActions';
// Component
import ClientDetails from './ClientDetails';

// import {
//   getProjectShortList,
//   updateProject,
// } from "../../Projects/projectsActions";

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  isLoading: state.client.isLoading,
  projectListIsLoading: state.project.isLoading,
  clientDetails: state.client.clientDetails,
  clientDeleteLoading: state.client.clientDeleteLoading,
  clientLocationDeleteLoading: state.client.clientLocationDeleteLoading,
  clientLocationList: state.client.clientLocationList,
  addOrUpdateclientLocalMapLoading:
    state.client.addOrUpdateclientLocalMapLoading,
  createdClientLocationInfo: state.client.createdClientLocationInfo,
  clientLocationCreateUpdateSuccess:
    state.client.clientLocationCreateUpdateSuccess,
  createdClientId: state.client.createdClientId,
  // Job-related props
  jobList: state.jobs.jobList,
  isLoadingJobs: state.jobs.isLoadingJobs,
  totaljobsCount: state.jobs.totaljobsCount,
  pageSizeJob: state.jobs.pageSizeJob,
  jobDeleteLoading: state.jobs.jobDeleteLoading,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getClientDetails: details => dispatch(getClientDetails({ ...details })),
  updateClient: details => dispatch(updateClient({ ...details })),
  deleteClient: details => dispatch(deleteClient({ ...details })),
  addClientLocation: details => dispatch(addClientLocation({ ...details })),
  getClientLocation: details => dispatch(getClientLocation({ ...details })),
  updateClientLocation: details =>
    dispatch(updateClientLocation({ ...details })),
  deleteClientLocation: details =>
    dispatch(deleteClientLocation({ ...details })),
  getJobList: params => dispatch(getJobList(params)),
  deleteJob: details => dispatch(deleteJob({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(ClientDetails);
